import { Button, Card } from "@sportsmet/ui";
import type { ReactNode } from "react";

import {
  buildCardCountdownLine,
  buildWinsMedalLine,
  CONFIRM_GATE_CARD_ACTION,
  CONFIRM_GATE_CARD_PRIVACY,
  CONFIRM_GATE_CARD_TITLE,
} from "./confirmGateCopy";
import type { typeConfirmGateEntrant } from "./confirmGateState";
import { ConfirmGateWinnerRow } from "./ConfirmGateWinnerRow";

export type typePoolHomeConfirmCardProps = {
  winners: readonly typeConfirmGateEntrant[];
  medalName: string;
  daysUntilAutoConfirm: number;
  onReviewAndConfirm: () => void;
};

export const PoolHomeConfirmCard = ({
  winners,
  medalName,
  daysUntilAutoConfirm,
  onReviewAndConfirm,
}: typePoolHomeConfirmCardProps): ReactNode => {
  const onlyWinner = winners.length === 1 ? winners[0] : undefined;

  return (
    <Card data-testid="pool-home-confirm-card">
      <p
        data-testid="pool-home-confirm-card-title"
        className="text-body font-bold text-warning"
      >
        {CONFIRM_GATE_CARD_TITLE}
      </p>
      {onlyWinner ? (
        <ConfirmGateWinnerRow
          displayName={onlyWinner.displayName}
          medalName={medalName}
          size="sm"
        />
      ) : (
        <p data-testid="pool-home-confirm-card-outcome">
          {buildWinsMedalLine({
            winnerNames: winners.map((winner) => winner.displayName),
            medalName,
          })}
        </p>
      )}
      <p
        data-testid="pool-home-confirm-card-info"
        className="text-caption text-ink-secondary"
      >
        {CONFIRM_GATE_CARD_PRIVACY}{" "}
        {buildCardCountdownLine(daysUntilAutoConfirm)}
      </p>
      <Button variant="outline" size="sm" onClick={onReviewAndConfirm}>
        {CONFIRM_GATE_CARD_ACTION}
      </Button>
    </Card>
  );
};
